import { api } from './client';

export type Favorite = {
  id: number;
  recipe_id: number;
  user_id: number;
  created_at: string;
  recipe?: {
    id: number;
    slug: string;
    title: string;
    description?: string;
    photo_url?: string;
    prep_time?: number;
    cook_time?: number;
    servings?: number;
  };
};

/**
 * Get all favorites for the current user
 */
export async function getFavorites(): Promise<Favorite[]> {
  const response = await api.get('/favorites');
  // Handle both direct array and wrapped response
  const favorites = Array.isArray(response.data) ? response.data : response.data.favorites || [];
  return favorites;
}

/**
 * Add a recipe to favorites
 */
export async function addFavorite(recipeId: number): Promise<Favorite> {
  const response = await api.post('/favorites', { recipe_id: recipeId });
  return response.data;
}

/**
 * Remove a recipe from favorites
 */
export async function removeFavorite(favoriteId: number): Promise<void> {
  await api.delete(`/favorites/${favoriteId}`);
}
